import { render, staticRenderFns } from "./DetailTNA.vue?vue&type=template&id=4134f3c9&scoped=true"
import script from "./DetailTNA.vue?vue&type=script&lang=js"
export * from "./DetailTNA.vue?vue&type=script&lang=js"
import style0 from "./DetailTNA.vue?vue&type=style&index=0&id=4134f3c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134f3c9",
  null
  
)

export default component.exports